import type { FaireProductEntity } from "../../entity_types/product";

export const p_mb2jtvya44: FaireProductEntity = {
  token: "p_mb2jtvya44",
  type: "product",
  name: "9 oz. Fraser Fir Soy Wax Candle",
  brandToken: "b_hma3kre8ec",
  brandName: "Heritage Valley Goods",
  imageUrl:
    "https://cdn.faire.com/fastly/1de8fc14e7b8382750b96c21717e5cfbe038e87689edf39ec149e380fdbd4365.jpeg",
  galleryImageUrls: [
    "https://cdn.faire.com/fastly/ffb9490615c1947d36ac6774f4d8d8c86240c844d6c281f74d464a3dce70d9b5.jpeg",
    "https://cdn.faire.com/fastly/bcb8b2d0f35660fa29d5935fd9609d73bd8b162c2d210801c5f6f5f04408389f.jpeg",
  ],
  priceDollars: 13,
  description:
    "Cypress | Evergreen | Moss\n\nOur day one holiday favorite, every fall/winter we are excited to offer this candle again—and every spring we are tempted to keep it in our year round rotation.\n\nAll of our fragrances are clean burning & toxin free. Our candles are 100% soy wax, and our labels are made of 100% recycled materials.",
  tags: [],
  msrpDollars: 24,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-07-23T04:52:21.239Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
